/** SCH-050: ICS (iCalendar) event generator */

function icsDate(d: Date): string {
  return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}

function escapeIcs(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

export interface ICSEvent {
  uid: string;
  summary: string;
  description?: string;
  location?: string;
  dtstart: Date;
  /** defaults to 1 hour after dtstart */
  dtend?: Date;
  organizer?: { name: string; email: string };
}

export function buildICSContent(events: ICSEvent[]): string {
  const now = icsDate(new Date());
  const lines: string[] = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//GoGrabJob B2B//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
  ];

  for (const ev of events) {
    const dtstart = icsDate(ev.dtstart);
    const dtend   = icsDate(ev.dtend ?? new Date(ev.dtstart.getTime() + 3600000));
    lines.push(
      'BEGIN:VEVENT',
      `UID:${escapeIcs(ev.uid)}`,
      `DTSTAMP:${now}`,
      `DTSTART:${dtstart}`,
      `DTEND:${dtend}`,
      `SUMMARY:${escapeIcs(ev.summary)}`,
    );
    if (ev.description) lines.push(`DESCRIPTION:${escapeIcs(ev.description)}`);
    if (ev.location)    lines.push(`LOCATION:${escapeIcs(ev.location)}`);
    if (ev.organizer)   lines.push(`ORGANIZER;CN=${escapeIcs(ev.organizer.name)}:mailto:${ev.organizer.email}`);
    lines.push('END:VEVENT');
  }

  lines.push('END:VCALENDAR');
  return lines.join('\r\n');
}

export function downloadICS(filename: string, events: ICSEvent[]): void {
  const content = buildICSContent(events);
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = filename.endsWith('.ics') ? filename : `${filename}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}
